var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://lbs.qq.com/tool/getpoint/index.html",
              target: "_blank"
            }
          },
          [_vm._v("1.position get - tengxun map")]
        ),
        _c("br"),
        _c("a", { attrs: { href: "https://cli.im/", target: "_blank" } }, [
          _vm._v("2.qrcode create")
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }